import { AfterViewInit, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../service/api.service';
import { DatePipe } from '@angular/common';
import { GroupDescriptor, SortDescriptor, State, process } from '@progress/kendo-data-query';
import {
  PageChangeEvent,
  GridComponent
} from '@progress/kendo-angular-grid';
import { LoaderService } from '../loader/loader.service';
import { GridSettingsService } from '../service/grid-settings.service';

@Component({
    selector: 'app-transaction',
    templateUrl: './transaction.component.html',
    styleUrls: ['./transaction.component.css'],
    providers: [DatePipe],
    standalone: false
})
export class TransactionComponent implements OnInit, AfterViewInit {
  @ViewChild("grid", { static: true }) gridKendo: GridComponent;
  public gridHeight: number;
  public gridData: any;
  transactionData: any = [];
  searchString: any = '';
  columnList: any = [];
  public groups: GroupDescriptor[] = [];
  state: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
    group: this.groups,
  };
  public sort: SortDescriptor[] = [
  ];
  total: number = 0;
  kendoLoading = false;
  public pageableWithAll: any = {
    pageSizes: [5, 10, 20, 50, 100, 'All']
  };
  subscriptionPlanList = [
    { text: "Essential", value: "1" },
    { text: "Proficient", value: "2" },
    { text: "Advanced", value: "3" },
    { text: "Elite", value: "4" },
    { text: "Basic Plan", value: "5" },
    { text: "Standard Plan", value: "6" },
    { text: "Premium Plan", value: "7" },
    { text: "Enterprise Plan", value: "8" }
  ];
  isDisableToggle: boolean = false;
  IsnotZero: boolean = true;
  TableName = "Transactions";
  constructor(private readonly api: ApiService, public datePipe: DatePipe, private readonly LoaderService: LoaderService,
    private readonly gridSettings: GridSettingsService) { }

  ngOnInit(): void {
    this.GetTransactionBigAmount();
    this.setGridHeight();
  }
  public dataStateChange(state: any): void {
    this.state = state;
    this.GetTransactionBigAmount();
  }
  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    this.GetTransactionBigAmount();
  }
  public pageChange(event: PageChangeEvent): void {
    this.state.skip = event.skip;
    this.GetTransactionBigAmount();
  }
  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.GetTransactionBigAmount();
  }

  private loadData(): void {
    this.gridData = process(this.transactionData, this.state);
    this.gridData = {
      data: this.transactionData,
      total: this.total,
    };
  }
  filterData(event: any) {
    this.searchString = event;
    this.state.skip = 0;
    this.state.filter = {
      logic: 'or',
      filters: [],
    };
    if (event) {
      this.state.filter.filters = this.columnList.map((field: any) => ({
        ignoreCase: true,
        value: event,
        operator: 'contains',
        field,
      }));
    }
    this.loadData();
    this.GetTransactionBigAmount();
  }


  GetTransactionBigAmount() {
    this.LoaderService.show();
    if (this.state.filter) this.state.filter.filters = [];
    this.api.GetTransactionBigAmount(this.state, JSON.stringify(this.searchString.trim()))
      .subscribe((res) => {
        const dataArray = res.Data?.Data || [];

        dataArray.forEach((e: any) => {
          e.Date = this.datePipe.transform(new Date(e.Date), 'dd-MM-yyyy hh:mm:ss a');

          let data = this.subscriptionPlanList.filter(x => x.value == e.SubscriptionPlanId);
          e.SubscriptionPlanId = data.length > 0 ? data[0].text : "";

          if (e.TotalAmount && e.IFOUR_CompanyMasterDto?.CurrencyObj) {
            e.TotalAmount = `${e.IFOUR_CompanyMasterDto?.TransactionCurrencyObj.CurrencySymbol} ${e.TotalAmount}`;
          }

          if (e.IFOUR_CompanyMasterDto?.CompanyName) {
            e.CompanyName = e.IFOUR_CompanyMasterDto.CompanyName;
          }

          if (e.IFOUR_CompanyMasterDto?.CompanyAddress) {
            e.CompanyAddress = e.IFOUR_CompanyMasterDto.CompanyAddress;
          }

          if (e.IFOUR_CompanyMasterDto?.IPAddress) {
            e.IPAddress = e.IFOUR_CompanyMasterDto.IPAddress;
          }

          e.TransactionCurrencyName = e.IFOUR_CompanyMasterDto?.TransactionCurrencyObj.CurrencyCode ?? '';
        });

        this.transactionData = dataArray;
        this.total = res.Data?.Total || 0;

        if (this.state.filter) {
          this.state.filter.filters = [];
        }

        this.columnList = [
          "TransactionNumber",
          "Date",
          "CreditCardNumber",
          "TotalAmount",
          "TransactionStatusStr",
          "UserName",
          "TransactionTypeName",
          "CompanyAddress",
          "CompanyName",
          "SubscriptionPlanId"
        ];

        this.loadData();
        this.LoaderService.hide();
      });
  }


  GetTransactionZeroAmount() {
    this.LoaderService.show();

    this.api.GetTransactionZeroAmount()
      .subscribe((res: any) => {
        // 1. pull out the inner array (or default to empty)
        const dataArray: any[] = Array.isArray(res.Data?.Data)
          ? res.Data.Data
          : [];

        // 2. map & format each record
        dataArray.forEach((e: any) => {
          // date → dd-MM-yyyy
          const rawDate = e.Date.split('T')[0];
          e.Date = this.datePipe.transform(new Date(rawDate), 'dd-MM-yyyy');
          const plan = this.subscriptionPlanList.find(x => x.value === e.SubscriptionPlanId);
          e.SubscriptionPlanId = plan ? plan.text : '';
          if (e.TotalAmount != null && e.IFOUR_CompanyMasterDto?.CurrencyObj) {
            e.TotalAmount = `${e.IFOUR_CompanyMasterDto?.TransactionCurrencyObj.CurrencySymbol} ${e.TotalAmount}`;
          }

          e.CompanyName = e.IFOUR_CompanyMasterDto?.CompanyName || '';
          e.CompanyAddress = e.IFOUR_CompanyMasterDto?.CompanyAddress || '';
          e.IPAddress = e.IFOUR_CompanyMasterDto?.IPAddress || '';
          e.TransactionCurrencyName = e.IFOUR_CompanyMasterDto?.TransactionCurrencyObj.CurrencyCode ?? '';
        });
        this.transactionData = dataArray;

        if (this.state.filter) {
          this.state.filter.filters = [];
        }

        this.columnList = [
          'TransactionNumber',
          'Date',
          'CreditCardNumber',
          'TotalAmount',
          'TransactionStatusStr',
          'UserName',
          'TransactionTypeName',
          'CompanyAddress',
          'CompanyName',
          'SubscriptionPlanId'
        ];

        // 4. refresh
        this.loadData();
        this.LoaderService.hide();

      }, err => {
        console.error('Error fetching zero-amount transactions', err);
      });
  }


  changeToggleVisit(event: any) {
    this.IsnotZero = event.value;
    if (this.IsnotZero) {
      this.GetTransactionBigAmount();

    }
    else {
      this.GetTransactionZeroAmount();
    }
  }


  clearList() {
    this.searchString = '';
    this.state.skip = 0;
    this.loadData();
    this.GetTransactionBigAmount();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.setGridHeight();
  }

  setGridHeight(): void {
    const headerHeight = 70; // Adjust according to your header and other elements
    const footerHeight = 61;
    const otherElementsHeight = 125;
    this.gridHeight = window.innerHeight - headerHeight - footerHeight - otherElementsHeight;
  }

  onColumnVisibilityChange(columnEvent: GridComponent): void {
    this.gridSettings.saveGridSettings(columnEvent, this.TableName).subscribe();
  }

  ngAfterViewInit(): void {
    this.gridSettings.applyGridSettings(this.api, this.TableName, this.gridKendo);
  }
}
